import React, { useEffect, useState } from "react";
import { Dropdown, Nav, Navbar } from "rsuite";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import * as userManager from "../../Services/UserSessionManager";
import { Link, useNavigate } from "react-router-dom";
import "./Home.css";
import { EmployeeInfoModal } from "../EmployeeTeamDetail/EmployeeInfomodal";
import { Modal } from "react-bootstrap";
export const RoleChangeBIManagerAndEmployee = () => {
  const [checkRole, setCheckRole] = useState(userManager.GetUserRole());

  const [loginid, setLoginid] = useState(userManager.GetUserLoginID());
  const [userName, setUserName] = useState(userManager.GetUserName());
  const [popup, setpopUp] = useState(false);
  const handleClose = () => setpopUp(false);
  return (
    <>
      <Dropdown
        title={"Role"}
        className="nav-bar-text-white"
        icon={
          <BootstrapIcon
            cssClasses="p-2 nav-bar-text-white"
            bootStrapIconName="person-circle"
            size={18}
          />
        }
      >
        <Modal show={popup} fullscreen={true} onHide={handleClose}>
          <EmployeeInfoModal id={loginid} title={userName} />
        </Modal>

        <Link className="link-simple" to={"/EmployeeRole"}>
          <Dropdown.Item
            icon={
              <BootstrapIcon
                bootStrapIconName={"keyboard-fill"}
                size={14}
                cssClasses={"pe-2"}
              />
            }
          >
            Employee
          </Dropdown.Item>
        </Link>
        <Link className="link-simple" to={"/BIManagerRole"}>
          <Dropdown.Item
            icon={
              <BootstrapIcon
                bootStrapIconName={"keyboard-fill"}
                size={14}
                cssClasses={"pe-2"}
              />
            }
          >
            BI Manager
          </Dropdown.Item>
        </Link>
      </Dropdown>
    </>
  );
};
